import { environment as devEnv } from './environment.dev';
import { AvailableEnvironments } from './models/available-environments';

export const availableEnvironments: AvailableEnvironments = [
  { name: devEnv.name, host: devEnv.host }
];
